import { render, staticRenderFns } from "./historialCompras.vue?vue&type=template&id=4c92dc27&"
import script from "./historialCompras.vue?vue&type=script&lang=js&"
export * from "./historialCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports